export default __webpack_public_path__ + "static/media/adblue.0769118c.svg";